export function Footer() {
  return (
    <footer className="bg-stone-100 text-slate-900 py-12 sm:py-16 px-4 sm:px-6 border-t border-slate-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 mb-8 sm:mb-12">
          <div>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 sm:mb-4 text-slate-900">Dr. Arash Yousefi, MD</h2>
            <p className="text-slate-600 text-xs sm:text-sm">
              Double Board-Certified in Neurology & Interventional Pain Management
            </p>
          </div>

          <div>
            <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-slate-900">Contact Information</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-slate-600 text-xs sm:text-sm">
                <i className="ri-phone-line text-emerald-600 flex-shrink-0"></i>
                <a href="tel:818-221-8000" className="hover:text-emerald-600 transition-colors cursor-pointer">
                  (818) 221-8000
                </a>
              </li>
              <li className="flex items-center gap-2 text-slate-600 text-xs sm:text-sm">
                <i className="ri-mail-line text-emerald-600 flex-shrink-0"></i>
                <a href="mailto:contact@neurotraumamg.com" className="hover:text-emerald-600 transition-colors cursor-pointer break-all">
                  contact@neurotraumamg.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-300 pt-6 sm:pt-8 text-center">
          <p className="text-slate-500 text-xs sm:text-sm px-4">
            Copyright © 2026 NeuroTrauma Medical Group. All rights reserved | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-600 transition-colors cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}